export class PurcharseDetail
{
    public productName: string;
    public productId: number;
    public quantity: number;
    public extraSku: boolean;
    public totalAmount: number;
}

export class PurcharseReponse
{
    public note: string;
    public listPurcharse: PurcharseDetail[];
}